import React   from 'react' ;
import PageCh17_t1 from './pageCh17_t1'; 
const   PageCh17 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh17  (chapter 17  Practice Project_ Adding Http & Forms To The Food Order App)</h1>
       <PageCh17_t1 />    
          
      </>
    )
     
} 
export default PageCh17
